import CartDetailedItem from "./CartDetailedItem.Component";

export default CartDetailedItem;
